<template>
  <el-form-item
    class="form form-select pos-relative"
    v-if="visible"
    :label="column.label"
    :prop="column.name"
    :class="(column.allowCreate ? 'with-custom-label' : '')">

    <template slot="label" v-if="column.hasOwnProperty('label')">
      <span class="inline-middle">{{ column.label }}</span>

      <el-tooltip v-if="column.prefixInfo" effect="dark"
        placement="top"
        popper-class="tooltip-content">
        <div slot="content" v-html="column.prefixInfo.label"></div>
        <i class="header-icon el-icon-info tooltip-info-icon"></i>
      </el-tooltip>

      <span v-if="column.allowCreate" style="color:purple">
        <el-tooltip effect="dark"
          placement="top"
          popper-class="tooltip-content">
          <div slot="content" v-html="'Enter text & select dropdown to input other options.'"></div>
          <i class="header-icon el-icon-plus tooltip-info-icon" style="font-size:0.7em;margin-left:3px;"></i>
        </el-tooltip>
      </span>
    </template>

    <el-select
      :name="column.name"
      v-model="form[column.name]"
      :disabled="disabled || false || (!method && column.loading)"
      :placeholder="column.placeholder || ''"
      :multiple="column.multiple"
      :filterable="column.hasOwnProperty('selectFilterable') ? column.selectFilterable : true"
      :clearable="column.selectClearable || undefined"
      :autocomplete="column.selectAutocomplete || 'off'"
      :auto-complete="column.selectAutocomplete || 'off'"
      :allow-create="column.allowCreate"
      :filter-method="column.filterMethod"
      :remote="column.remote"
      :reserve-keyword="column.reserveKeyword"
      :remote-method="method"
      :loading="column.loading"
      :loading-text="column.loading ? 'loading...' : undefined"
      style="width:100%;">
      <!-- <div slot="prefix">
        <el-tag v-if="(typeof form[column.name] === 'string' && form[column.name].length > 0)" size="small" type="primary">
          New
        </el-tag>
      </div> -->
      <el-option
        v-for="(option, oindex) in (optionsVisible || [])"
        :key="`${oindex}`"
        :value="option.id"
        :label="option.label">
        {{ option.label }}
      </el-option>
    </el-select>

    <i v-if="column.loading" class="el-icon-loading" style="position:absolute;bottom:12px;right:-16px;"></i>
  </el-form-item>
</template>

<script>
import _ from 'lodash'

// https://stackoverflow.com/questions/12374442/chrome-ignores-autocomplete-off

export default {
  name: 'form-select',
  components: {
  },
  props: ['findex', 'column', 'form', 'options', 'method', 'disabled'],
  data () {
    return {
      visible: true,
    }
  },
  computed: {
    modules: function () {
      return this.$store.getters.user.modules
    },

    info: function () {
      let column = this.column
      return {
        findex: this.findex,
        ...column,
        options: this.options,
        value: this.form[column && column.name]
      }
    },

    optionsVisible: function () {
      let options = this.options
      if (options && Array.isArray(options)) {
        return _.filter(options, (item) => !item.hidden)
      }
      return []
    },

    dataWatch: function () {
      if (!this.form || !this.column || !this.column.name) {
        return undefined
      }
      return this.form[this.column.name]
    },
  },
  watch: {
    'dataWatch': function (value, valueOld) {
      this.onSelectChanged(this.column, { value, valueOld })
    },

    // method: async function () {
    //   this.$set(this, 'visible', false)
    //   await this.$nextTick()
    //   this.$set(this, 'visible', true)
    // }
  },
  created () {
  },
  mounted () {
    this.refresh()
  },
  methods: {
    async refresh () {
    },

    onSelectChanged (info, data) {
      // let value = this.form[this.column.name]
      // let info = _.assign({}, this.column, { value })
      info = _.assign({}, info, data)
      this.$emit('on-select-changed', info)
    }
  }
}
</script>

<style lang="scss">
@import "../styles/base.scss";

.form-select {
  .with-custom-label {
    display: flex;
    flex-direction: column;
    // .el-form-item__label {
    //   z-index: 1;
    // }
    // .el-form-item__content {
    //   z-index: -1;
    // }
  }
}

</style>
